import React from 'react';

import { EBoxLocationButton } from './EBoxLocationButton';

import { useCarOperations, useHasCarEBoxLocations, useIsCarEBoxLocationsDone } from 'entities/cars';
import { useIsAutorizedUser } from 'store/features/auth/selectors';
import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';
import { useApplicationOperations } from 'entities/application';

import { MODALS } from 'entities/application';

export const CarEBoxLocationsButton = () => {
  const { resetCarEBoxLocations, getCarEBoxLocations, resetCarEBoxDashboardData } = useCarOperations();
  const hasCarEBoxLocations = useHasCarEBoxLocations();
  const isCarEBoxLocationsDone = useIsCarEBoxLocationsDone();
  const isAutorizedUser = useIsAutorizedUser();
  const { setActiveModals } = useApplicationOperations();

  return (
    <>
      <EBoxLocationButton
        onClick={async () => {
          if (isCarEBoxLocationsDone && hasCarEBoxLocations) {
            resetCarEBoxLocations();
            resetCarEBoxDashboardData();
            return;
          }

          if (!isAutorizedUser) {
            setActiveModals([MODALS.logIn]);
            return;
          }

          logAmplitudeEvent('clickMyFleetButton');
          try {
            await getCarEBoxLocations();
          } catch (e) {}
        }}
      />
    </>
  );
};
